import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Input, Label } from 'reactstrap';
import { Select, Checkbox } from 'antd';
// Local Deps
import NFButton from '../../../../components/primitives/NFButton';
import msgs from '../../../../config/messages';

// import Loading from '../../components/Loading';

function CollectProcurmentAgency({
    onSelect,
    onChange,
    onSubmit,
    onCancel,
    procurementGroupList,
    inputProcGrp,
    cage,
    continueWithoutRFQ,
}) {
    return (
        <div>
            <Row style={{ flexWrap: 'nowrap' }}>
                <Col style={{ marginTop: '16px' }}>
                    <div className="nf-registration__content">
                        <Row className="nf-row--justify-end" />
                        <div className="nf-registration__layout">
                            <div className="nf-registration__input_select">
                                <Label className="nf-registration__lbl">Find your RFQ Group: </Label>
                                <Select
                                    id='selectProcGrp'
                                    name='selectProcGrp'
                                    showSearch
                                    style={{ width: '100%' }}
                                    // mode='tags'
                                    placeholder="Select an existing RFQ Group"
                                    value={cage === "OG000" || cage === "O0000" ? null : cage}
                                    optionFilterProp="children"
                                    onChange={onSelect}
                                    allowClear
                                    disabled={inputProcGrp !== "" || continueWithoutRFQ}
                                    filterOption={(input, option) =>
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {procurementGroupList}
                                </Select>
                            </div>

                            <div className="nf-registration__input">
                                <Label className="nf-registration__lbl">Create a new RFQ Group:</Label>
                                <Input
                                    id='inputProcGrp'
                                    name='inputProcGrp'
                                    showSearch
                                    style={{ width: '100%' }}
                                    placeholder="Create a new RFQ Group"
                                    optionFilterProp="children"
                                    onChange={onChange}
                                    value={inputProcGrp}
                                    disabled={cage !== "OG000"}
                                >
                                    {/* {procurementGroupList} */}
                                </Input>
                            </div>
                            <div className="nf-registration__input">
                                <Label className="nf-registration__lbl">Continue without RFQ Group:</Label>
                                <Checkbox
                                    name="continueWithoutRFQ"
                                    onChange={onChange}
                                    style={{ textAlign: 'left' }}
                                    checked={continueWithoutRFQ}
                                    disabled={inputProcGrp !== "" || (cage !== "OG000" && cage !== "O0000")}
                                >
                                    I am a Government Employee/Contractor who DOES NOT have RFQ Capabilities for my Agency. I will be using ICON for research on Industry Tooling and Supplier Capabilities only.
                                </Checkbox>
                            </div>

                            <div className="nf-registration--wrapper">
                                <div className="nf-registration__buttons">
                                    <NFButton
                                        className="nf-button--gray-border"
                                        style={{ marginRight: '16px' }}
                                        onClick={() => {
                                            onCancel();
                                        }}
                                    >
                                        {msgs.Form.cancelButton}
                                    </NFButton>
                                    <NFButton
                                        className="nf-button--form nf-button--orange"
                                        type="submit"
                                        disabled={cage === "OG000" && inputProcGrp === ""}
                                        onClick={() => {
                                            onSubmit();
                                        }}
                                    >
                                        {msgs.Form.continueButton}
                                    </NFButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    );
}

CollectProcurmentAgency.propTypes = {
    onSelect: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    procurementGroupList: PropTypes.any.isRequired,
    inputProcGrp: PropTypes.string.isRequired,
    cage: PropTypes.string.isRequired,
    continueWithoutRFQ: PropTypes.bool.isRequired,
};

export default CollectProcurmentAgency;




// WEBPACK FOOTER //
// ./src/pages/Registration/subComponents/CollectProcurmentAgency/CollectProcurmentAgency.jsx